import { ANDROID_PLAY_STORE_URL, IOS_APP_STORE_URL } from "../../../constantes";
import AppStore from "../../../images/appStore.png";
import PlayStore from "../../../images/playStore.png";

export const Store = () => {
  return (
    <div style={styles.div}>
      <div
        onClick={() => (window.location.href = IOS_APP_STORE_URL)}
        style={styles.button}
      >
        <img style={styles.img} src={AppStore} alt="AppStore" />
      </div>
      <div
        onClick={() => (window.location.href = ANDROID_PLAY_STORE_URL)}
        style={styles.button}
      >
        <img style={styles.img} src={PlayStore} alt="PlayStore" />
      </div>
    </div>
  );
};

const styles = {
  div: {
    display: "flex",
    flexDirection: "row",
    marginTop: 20,
    alignItems: "center",
  },
  img: {
    //width: 300,
    width: "100%",
  },
  button: {
    marginRight: 10,
    borderRadius: 15,
    cursor: "pointer",
  },
};
